<template>
	<div class="webhookEventListenWrapper">
		<div class="eventListen">
			<div class="pulse-ring"></div>
			<i class="icon-lightning" aria-hidden="true"></i>
		</div>
		<h3 style="text-align: center; margin-top: 40px">Listening For Event</h3>
		<slot></slot>
	</div>
</template>

<script>
export default {};
</script>

<style scoped>
.webhookEventListenWrapper {
	position: absolute;
	z-index: 10000;
	width: 170px;
	margin: auto;
	left: 0;
	right: 0;
	top: 20%;
}

.eventListen {
	border: none;
	padding: 0;
	border-radius: 100%;
	width: 70px;
	height: 70px;
	font-size: 1.5em;
	color: #fff;
	padding: 0;
	margin: 0;
	background: #210f3c;
	position: relative;
	z-index: 999;
	line-height: 75px;
	text-align: center;
	display: block;
	margin: auto;
}

.pulse-ring {
	content: "";
	width: 100px;
	height: 100px;
	background: rgb(233, 231, 236);
	border: 5px solid rgb(233, 231, 236);
	border-radius: 50%;
	position: absolute;
	top: -20px;
	left: -20px;
	animation: pulsate infinite 1.5s;
}

@-webkit-keyframes pulsate {
	0% {
		-webkit-transform: scale(1, 1);
		opacity: 1;
	}
	100% {
		-webkit-transform: scale(1.3, 1.3);
		opacity: 0;
	}
}

@keyframes pulsate {
	0% {
		-webkit-transform: scale(1, 1);
		opacity: 1;
	}
	100% {
		-webkit-transform: scale(1.3, 1.3);
		opacity: 0;
	}
}
</style>
